(function () {
	const initProductAccordion = () => {
		$('.product__additional').click(function() {
			if (!$(this).hasClass('active')) {
				$('.product__additional.active').removeClass('active');
				$(this).addClass('active');
				$('.product__additional-description').hide().eq($(this).index()).slideDown(300);
			}
		});
	};

	document.addEventListener('shopify:section:load', function () {
		$('.js-media-list').slick(getSliderSettings());
		$('.js-media-sublist').slick(getSubSliderProductSettings());

		setTimeout(function () {
			$('.js-media-list').slick('refresh');
			$('.js-media-sublist').slick('refresh');
		}, 100)

		initProductAccordion();
		initModal('fancy-container-info');
	});

	initModal('fancy-container-info');
	initProductAccordion();

	$(window).on('resize', function () {
		$('.js-media-sublist').slick('refresh');
	});
})();
